// 播放meta
import ErrorHandler from "@/utils/errorHandler";
import message from "../utils/message";
import { tech } from "@gtt/service-sdk";
import store from "@/store";

const BindAccountRequest =
  tech.gtt.frontapp.servicesdk.interfaces.service.account.BindAccountRequest;
const LogoffRequest =
  tech.gtt.frontapp.servicesdk.interfaces.service.account.LogoffRequest;
const LoginMethod =
  tech.gtt.frontapp.servicesdk.interfaces.service.account.LoginMethod;
const UnBindAccountRequest =
  tech.gtt.frontapp.servicesdk.interfaces.service.account.UnBindAccountRequest;
const CheckPasswordRequest =
  tech.gtt.frontapp.servicesdk.interfaces.service.account.CheckPasswordRequest;
const ChangeBindAccountRequest =
  tech.gtt.frontapp.servicesdk.interfaces.service.account
    .ChangeBindAccountRequest;
const PackageSubscribeRequest =
  tech.gtt.frontapp.servicesdk.interfaces.service.bill.PackageSubscribeRequest;
const QueryUserSubscriptionRequest =
  tech.gtt.frontapp.servicesdk.interfaces.service.bill.QueryUserSubscriptionRequest;
const VerificationCodeRequest =
  tech.gtt.frontapp.servicesdk.interfaces.service.account.VerificationCodeRequest;
const VerifyCodeActionType =
  tech.gtt.frontapp.servicesdk.interfaces.service.account.VerifyCodeActionType;
const LoginRequest =
  tech.gtt.frontapp.servicesdk.interfaces.service.account.LoginRequest;

/**
 * Code Login
 * @param sdkContent 
 * @param rechargeCode 
 * @param savePwd 是否记住密码
 * @returns 
 */
export async function codeLoginSDK(sdkContent: any, rechargeCode: string, savePwd = false) {
  try {
    const loginRequest = LoginRequest.Companion.rechargeCardCode(
      rechargeCode.trim(),
      null,
      savePwd
    );
    const codeLoginResp = await new Promise((resolve, reject) => {
      sdkContent
        .getAccountService()
        .login(loginRequest)
        .proceedWithCallback({
          __doNotUseOrImplementIt: {},
          onSuccess: resolve,
          onFail: reject,
        });
    });
    return codeLoginResp;
  } catch (error: any) {
    throw new Error((error as any)?.message || "Unknown error");
  }
}

// 获取账户信息
export async function getAccountInfo(sdkContent: any) {
  try {
    const accountInfoResp = (await new Promise((resolve, reject) => {
      sdkContent
        .getAccountService()
        .account()
        .fetchUserInfo(false)
        .proceedWithCallback({
          onSuccess: resolve,
          onFail: reject,
        });
    })) as any;
    return accountInfoResp;
  } catch (exception: any) {
    message.error(exception?.message || "Unknown error");
  }
}

// 获取用户订阅列表
export async function getSubscriptionList(sdkContent: any) {
  const subscriptionListResp = (await new Promise((resolve, reject) => {
    sdkContent.getBillService().queryUserSubscription(QueryUserSubscriptionRequest.Companion.all()).proceedWithCallback({
      onSuccess: resolve,
      onFail: reject,
    });
  })) as any;
  return subscriptionListResp.asJsArrayView() || [];
}

// 获取用户最新订阅变更列表
export async function getSubscriptionUpdateList(sdkContent: any) {
  const subscriptionUpdateListResp = (await new Promise((resolve, reject) => {
    sdkContent.getBillService().querySubscriptionUpdate().proceedWithCallback({
      onSuccess: resolve,
      onFail: reject,
      });
    })) as any;
  return subscriptionUpdateListResp.asJsArrayView() || [];
}

/**
 * 通过充值码充值
 * @param sdkContent
 * @param rechargeCode
 * @returns
 */
export async function rechargeByCode(sdkContent: any, rechargeCode: string) {
  try {
    const rechargeByCodeResp = (await new Promise((resolve, reject) => {
      sdkContent.getBillService().rechargeByCode(rechargeCode).proceedWithCallback({
        onSuccess: resolve,
        onFail: reject,
      });
    })) as any;
    store.commit("set_profile_list_update", true);
    return rechargeByCodeResp;
  } catch (exception: any) {
    throw new Error(exception?.message || "Unknown error");
    return null;
  }
}

/**
 * 领取7天试用期
 * @param sdkContent
 * @returns
 */
export async function getFreeTrial(sdkContent: any, packageId: string) {
  await new Promise((resolve, reject) => {
    sdkContent
      .getBillService()
      .subscribePackage(PackageSubscribeRequest.Companion.subscribe(packageId))
      .proceedWithCallback({
        __doNotUseOrImplementIt: {},
        onSuccess: resolve,
        onFail: reject,
      });
  });
}

/**
 * 领取7天并注册手机号试用期
 * @param sdkContent
 * @param packageId
 * @param account
 * @param areaCode
 * @param verificationCode
 * @returns
 */
export async function getFreeTrialAndRegisterPhone(sdkContent: any, packageId: string, account: string, areaCode: string, verificationCode: string) {
  try {
    await new Promise((resolve, reject) => {
      sdkContent
        .getBillService()
        .subscribePackage(PackageSubscribeRequest.Companion.subscribe(packageId, areaCode + account, areaCode, verificationCode))
        .proceedWithCallback({
          __doNotUseOrImplementIt: {},
          onSuccess: resolve,
          onFail: reject,
        });
    });
  } catch (exception: any) {
    throw new Error(exception?.message || "Unknown error");
  }
}

/**
 * 获取用户的免费套餐信息
 * @param sdkContent
 * @returns
 */
export async function getFreeTrialPackageInfo(sdkContent: any) {
  try {
    const freeTrialPackageInfoResp = (await new Promise((resolve, reject) => {
      sdkContent.getBillService().queryUserSubscription(QueryUserSubscriptionRequest.Companion.freeTrial()).proceedWithCallback({
        onSuccess: resolve,
        onFail: reject,
      });
    })) as any;
    return freeTrialPackageInfoResp;
  } catch (exception: any) {
    return null;
  }
}

/**
 * 账户注销
 */
export async function logoffAccount(
  sdkContent: any,
  account: string,
  password: string,
  loginMethod: any,
  areaCode: string
) {
  try {
    let logoffRequest: any = null;
    if (loginMethod === LoginMethod.Email) {
      logoffRequest = LogoffRequest.Companion.logoff(
        account,
        password,
        loginMethod
      );
    } else {
      logoffRequest = LogoffRequest.Companion.logoffPhone(
        account,
        areaCode,
        password,
        loginMethod
      );
    }
    const logoffResp = await new Promise((resolve, reject) => {
      sdkContent.getAccountService().logoff(logoffRequest).proceedWithCallback({
        onSuccess: resolve,
        onFail: reject,
      });
    });
    return logoffResp;
  } catch (exception: any) {
    throw new Error(exception);
  }
}


/**
 * 发送验证码
 * @param sdkContent
 * @param phoneNumber
 * @param areaCode
 * @returns
 */
export async function sendVerificationCode(sdkContent: any, isPhone: boolean, account: string, areaCode = "", isWhatsApp = false) {
  try {
    const verificationCodeRequest = isPhone ? VerificationCodeRequest.Companion.phone(
      areaCode + account,
      areaCode,
      isWhatsApp ? VerifyCodeActionType.WHATSAPP_REGISTER : VerifyCodeActionType.REGISTER
    ) : VerificationCodeRequest.Companion.email(
      account,
      VerifyCodeActionType.REGISTER
    );
    await new Promise((resolve, reject) => {
      sdkContent
        .getAccountService()
        .sendVerificationCode(verificationCodeRequest)
        .proceedWithCallback({
          __doNotUseOrImplementIt: {},
          onSuccess: resolve,
          onFail: reject,
        });
    });
  } catch (exception: any) {
    ErrorHandler.handleSDKError(exception);
    throw new Error(exception?.message || "Unknown error");
  }
}
/**
 * 绑定账号
 * @param sdkContent
 * @param account 账号
 * @param areaCode 区号
 * @param verificationCode 验证码
 * @param isEmail 是否是邮箱
 * @returns
 */
export async function bindAccount(
  sdkContent: any,
  account: string,
  verificationCode: number,
  isEmail: boolean,
  areaCode?: string
) {
  try {
    const bindAccountRequest = isEmail
      ? BindAccountRequest.Companion.bindEmailForRegisteredUser(
          account,
          verificationCode
        )
      : BindAccountRequest.Companion.bindPhoneForRegisteredUser(
          areaCode + account,
          areaCode || "",
          verificationCode
        );
    const bindResp = (await new Promise((resolve, reject) => {
      sdkContent
        .getAccountService()
        .bindAccount(bindAccountRequest)
        .proceedWithCallback({
          onSuccess: resolve,
          onFail: reject,
        });
    })) as any;
    return bindResp;
  } catch (exception: any) {
    ErrorHandler.handleSDKError(exception);
    throw exception;
  }
}

export async function bindAccountWithPassword(
  sdkContent: any,
  account: string,
  password: string,
  verificationCode: number,
  isEmail: boolean,
  areaCode?: string
) {
  try {
    const bindAccountRequest = isEmail
      ? BindAccountRequest.Companion.bindNewEmailForUnregisteredUser(
          account,
          password,
          verificationCode,
        )
      : BindAccountRequest.Companion.bindNewPhoneForUnregisteredUser(
          areaCode + account,
          password,
          areaCode || "",
          verificationCode,
        );
    const bindResp = (await new Promise((resolve, reject) => {
      sdkContent
        .getAccountService()
        .bindAccount(bindAccountRequest)
        .proceedWithCallback({
          onSuccess: resolve,
          onFail: reject,
        });
    })) as any;
    return bindResp;
  } catch (exception: any) {
    ErrorHandler.handleSDKError(exception);
    throw exception;
  }
}

/**
 * 解绑定
 * @param sdkContent 解绑定
 * @param isEmail 是否是邮箱
 * @param areaCode 区号
 * @returns
 */
export async function unBindAccount(
  sdkContent: any,
  isEmail: boolean,
  areaCode?: string
) {
  try {
    const unBindAccountRequest = isEmail
      ? UnBindAccountRequest.Companion.unBindEmail()
      : UnBindAccountRequest.Companion.unBindPhone();
    const accountInfoResp = (await new Promise((resolve, reject) => {
      sdkContent
        .getAccountService()
        .unBindAccount(unBindAccountRequest)
        .proceedWithCallback({
          onSuccess: resolve,
          onFail: reject,
        });
    })) as any;
    return accountInfoResp;
  } catch (exception: any) {
    ErrorHandler.handleSDKError(exception);
  }
}

/**
 * 修改绑定
 * @param sdkContent
 * @param account 账号
 * @param areaCode 区号
 * @param verificationCode 验证码
 * @param isEmail 是否是邮箱
 */
export async function modifyBindAccount(
  sdkContent: any,
  account: string,
  verificationCode: number,
  isEmail: boolean,
  areaCode?: string
) {
  try {
    const changebindAccountRequest = isEmail
      ? ChangeBindAccountRequest.Companion.changeEmail(
          account,
          verificationCode.toString()
        )
      : ChangeBindAccountRequest.Companion.changePhone(
          areaCode || "",
          areaCode + account,
          verificationCode.toString()
        );
    const modifyBindResp = (await new Promise((resolve, reject) => {
      sdkContent
        .getAccountService()
        .changeBindAccount(changebindAccountRequest)
        .proceedWithCallback({
          onSuccess: resolve,
          onFail: reject,
        });
    })) as any;
    return modifyBindResp;
  } catch (exception: any) {
    ErrorHandler.handleSDKError(exception);
  }
}

/**
 * 获取手机号区号列表
 * @param sdkContent
 * @returns
 */
export function getPhoneAreaList(sdkContent: any) {
  const configService = sdkContent.getConfigService();
  const phoneAreasResp = configService.getCountryCodeList();
  return phoneAreasResp.asJsArrayView();
}

/**
 * 密码校验
 */
export async function checkPassword(
  sdkContent: any,
  account: string,
  password: string,
  loginType: string
) {
  try {
    const checkPasswordRequest = CheckPasswordRequest.Companion.check(
      account,
      password,
      loginType === "email" ? LoginMethod.Email : LoginMethod.Phone
    );
    const accountInfoResp = (await new Promise((resolve, reject) => {
      sdkContent
        .getAccountService()
        .checkPassword(checkPasswordRequest)
        .proceedWithCallback({
          onSuccess: resolve,
          onFail: reject,
        });
    })) as any;
    console.log("密码校验 accountInfoResp:", accountInfoResp);
    return accountInfoResp;
  } catch (exception: any) {
    ErrorHandler.handleSDKError(exception);
  }
}

/**
 * 退出登录
 * @param sdkContent
 * @returns
 */
export async function logoutAccount(sdkContent: any) {
  await sdkContent.getAccountService().logout().proceedWithCallback();
  // 清除vuex store
  // 重置主 store
  store.commit("resetState");
  // 重置 modules
  store.commit("vod/resetState");
  store.commit("live/resetState");
  console.log("退出登录成功");
}
